<template>
  <div class="bank-foot">
    <van-button class="web-btn" style="width: calc(100vw - 32px);margin: 10px 16px;" @click="toAdd">{{ $t('common.binding') }}</van-button>
  </div>
</template>

<script>
export default {
  name: 'BankFooter',
  methods:{
    toAdd(){
        this.$emit('toShow',{})
    }
  }
}
</script>

<style>

</style>
